module.exports = __webpack_public_path__ + "static/img/solar-energy-01.4cff43f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/solar-energy/solar-energy-01.jpg
// module id = SgSD
// module chunks = 96